import React from 'react';
import './About.css';

const About: React.FC = () => {

  return (
    <div className="about-page">
      <div className="about-header">
        <h1>About the Store</h1>
      </div>

      <div className="about-content">
        <div className="about-card">
          <div className="about-hero">
            <span className="hero-icon">🏪</span>
            <h2>Your Trusted Shopping Destination</h2>
            <p>Quality Products • Unbeatable Prices • Exceptional Service</p>
          </div>

          <div className="about-section">
            <h3>📖 Our Story</h3>
            <p><strong>Gimbiya Value Store</strong> was founded with a simple vision: to provide Nigerian shoppers with access to high-quality foreign products from the <strong>US</strong>, <strong>UK</strong>, <strong>China</strong>, <strong>Korea</strong>, and <strong>other international markets</strong> at affordable prices. What started as a small retail venture has grown into a trusted e-commerce destination, serving thousands of satisfied customers across the country.</p>
            <p>We believe that everyone deserves to enjoy quality products without breaking the bank. That's why we carefully curate our collection, ensuring each item meets our strict standards for quality, durability, and value.</p>
          </div>

          <div className="about-section">
            <h3>🎯 Our Mission</h3>
            <p>To empower our customers by offering exceptional products that enhance their lifestyle, while ensuring affordability, convenience, and outstanding customer service. We strive to make every shopping experience memorable, rewarding, and hassle-free.</p>
          </div>

          <div className="about-section">
            <h3>🌟 What We Offer</h3>
            <div className="offerings-grid">
              <div className="offering-item">
                <span>👟</span>
                <div>
                  <strong>Premium Footwear</strong>
                  <p>Stylish and comfortable shoes for every occasion - from casual sneakers to elegant heels</p>
                </div>
              </div>
              <div className="offering-item">
                <span>👜</span>
                <div>
                  <strong>Fashion Bags & Accessories</strong>
                  <p>Trendy handbags, backpacks, and accessories that complement your unique style</p>
                </div>
              </div>
              <div className="offering-item">
                <span>🏠</span>
                <div>
                  <strong>Home & Kitchen Essentials</strong>
                  <p>Quality products that make your living space comfortable and functional</p>
                </div>
              </div>
              <div className="offering-item">
                <span>📚</span>
                <div>
                  <strong>School & Travel Gear</strong>
                  <p>Durable and practical solutions for students and travelers</p>
                </div>
              </div>
              <div className="offering-item">
                <span>👕</span>
                <div>
                  <strong>Quality Clothing</strong>
                  <p>Fashion-forward apparel for men, women, and children</p>
                </div>
              </div>
              <div className="offering-item">
                <span>👕</span>
                <div>
                  <strong>Importation Services</strong> 
                  <p>We specialize in importation services for high-quality foreign products for our customers</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h3>💚 Why Choose Us?</h3>
            <div className="values-grid">
              <div className="value-item">
                <strong>✅ Quality Guaranteed</strong>
                <p>Every product is carefully inspected before shipping</p>
              </div>
              <div className="value-item">
                <strong>🚚 Fast Delivery</strong>
                <p>Reliable shipping across Nigeria</p>
              </div>
              <div className="value-item">
                <strong>💳 Secure Payments</strong>
                <p>Multiple payment options with secure encryption</p>
              </div>
              <div className="value-item">
                <strong>🔄 Easy Returns</strong>
                <p>Hassle-free return policy within 7 days. Initialize your return request through our App. Terms & Conditions apply.</p>
              </div>
              <div className="value-item">
                <strong>⭐ Rewards Program</strong>
                <p>Use our App to earn points on every purchase and redeem for discounts. Your points can be used towards future purchases.</p>
              </div>
              <div className="value-item">
                <strong>💬 Customer Support</strong>
                <p>We offer 24/7 customer support. Chat with Amaya by clicking the chat icon at the bottom right of the page.</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h3>📞 Contact Us</h3>
            <div className="contact-info">
              <p><strong>📧 Email:</strong> support@gimbivaluestore.com</p>
              <p><strong>📍 Headquarters:</strong> Gimbiya Value Store, Zango, Zaria, Kaduna State, Nigeria</p>
              <p><strong>⏰ Hours:</strong> Monday - Saturday, 9:00 AM - 6:00 PM</p>
              <p><strong>📱 Phone:</strong> +2347010110977</p>
            </div>
          </div>
        </div>

        {/* Footer with Developer Credits */}
        <div className="about-footer">
          <p className="version">Version 1.0.0</p>
          <p className="developer-credit">
            Developed by <strong>BTO</strong> | © {new Date().getFullYear()} Gimbiya Value Store
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;